<template>
  <footer :class="ns.b()" :style="style">
    <slot />
  </footer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'

import type { CSSProperties } from 'vue'

interface FooterProps {
  /**
   * @description height of the footer
   */
  height?: string | null
}

defineOptions({
  name: 'ZFooter',
})
const props = withDefaults(defineProps<FooterProps>(), {
  height: null,
})

const ns = useNamespace('footer')

const style = computed(
  () =>
    (props.height
      ? ns.cssVarBlock({ height: props.height })
      : {}) as CSSProperties
)
</script>
